import validate from "/agent/_work/2/s/front/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@9.27.0_jiti@2.4_22da3ade47870323d82c471ea39c0799/node_modules/nuxt/dist/pages/runtime/validate.js";
import roles_45global from "/agent/_work/2/s/front/middleware/roles.global.ts";
import manifest_45route_45rule from "/agent/_work/2/s/front/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@9.27.0_jiti@2.4_22da3ade47870323d82c471ea39c0799/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  roles_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}